import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, DownloadFile, GetQuery } from './Shared';

interface GenericListItem {
    id: number;
    name: string;
}

const ReportSalesByBranchAndProductGroupSummaryData = () => {
    let navigate = useNavigate();
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [branchId, setBranchId] = React.useState(-1);
    const [branchOptions, setBranchOptions] = React.useState<GenericListItem[]>([]);
    const [productGroupId, setProductGroupId] = React.useState(-1);
    const [productGroupOptions, setProductGroupOptions] = React.useState<GenericListItem[]>([]);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            getBranches();
        } else {
            navigate("/accessdenied")
        }
    }

    const getBranches = async () => {
        const apiUrl = "GetAllBranches";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setBranchOptions(result.data);
            getProductGroups();
        }
    }

    const getProductGroups = async () => {
        const apiUrl = "GetProductGroups";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setProductGroupOptions(result.data);
            setLoading(false);
        }
    }

    const handleBranchIdChange = (e: any) => {
        let error = errors;
        delete error["branchId"];
        setErrors(error);
        var branchIdValue = e.target.value * 1;
        setBranchId(branchIdValue);
    }

    const handleProductGroupIdChange = (e: any) => {
        let error = errors;
        delete error["productGroupId"];
        setErrors(error);
        var prodGrpIdValue = e.target.value * 1;
        setProductGroupId(prodGrpIdValue);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (branchId < 1) {
            formIsValid = false;
            errorList["branchId"] = "Branch is required";
        }

        if (productGroupId < 1) {
            formIsValid = false;
            errorList["productGroupId"] = "Product Group is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            runRpt();
        }
    }

    const runRpt = () => {
        var url = "/report/SalesByBranchAndProductGroupSummaryReport/-1/-1/" + branchId + "/" + productGroupId + "/-1";
        window.open(url, '_blank');
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const apiURL = "ExportSalesByBranchAndProductGroupSummaryReportData?BranchId=" + branchId + "&ProductGroupId=" + productGroupId;
        var filename = "SalesByBranchAndProductGroupSummary.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Sales by Branch and Product Group Summary Report</h1>
            </div>
            <div className="marginTop20">
                <span>Select a Branch and Product Group to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="branchId">
                    <span className="label">Branch</span>
                    <select className="select" id="branchId" name="branchId" value={branchId} onChange={(e) => handleBranchIdChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {branchOptions.map(branch =>
                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                        )};
                    </select>
                </label>
                <span className={errors["branchId"] ? "label errors marginLeftLabel" : "hidden"}>{errors["branchId"]}</span>

                <label className="input-group" htmlFor="productGroupId">
                    <span className="label">Product Group</span>
                    <select className="select" id="productGroupId" name="productGroupId" value={productGroupId} onChange={(e) => handleProductGroupIdChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {productGroupOptions.map(productGroup =>
                            <option key={productGroup.id} value={productGroup.id}>{productGroup.name}</option>
                        )};
                    </select>
                </label>
                <span className={errors["productGroupId"] ? "label errors marginLeftLabel" : "hidden"}>{errors["productGroupId"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel marginRight10" type='button' onClick={runReport}>Run Report</button>
            <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportSalesByBranchAndProductGroupSummaryData;